export default class QuestionGroup {
    constructor(id, name){
        this.id = id;
        this.name = name;
        this.questions = [];
    }
}